module.exports = __webpack_public_path__ + "static/Pride-24d81e9db22c2c362fd249d38ca92e21.jpg";